import React, {useCallback} from 'react';
import {useLocation} from 'react-router-dom';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';
import Heading from 'js/components/Common/Heading/Heading';
import Thumbnail from 'js/components/Common/Thumbnail/Thumbnail';
import Description from 'js/components/Common/Description/Description';
import PostDuration from 'js/components/Common/PostDuration/PostDuration';
import ProductLabelsList from 'js/components/Common/ProductLabelList/ProductLabelsList';
import VisibilityViewerIcon from 'js/components/Common/VisibilityViewerIcon/VisibilityViewerIcon';

import Label from '../../components/Label/Label';
import commonClasses from '../../../SearchResultsItem/SearchResultsItem.module.pcss';


export interface Props {
    data: {
        id: number,
        title: string,
        link: string,
        featuredImage: {
            url: string,
            altText: string
        },
        type: 'courses',
        duration: number,
        description: string,
        isPremium: boolean
    },
    isPromoted: boolean,
    isAISearch: boolean
}

const Course = ({data, isPromoted, isAISearch}:Props) => {
    const location = useLocation();

    const sendMixPanelEvent = useCallback(async () => {
        await MixPanelWrapper.TrackEvent(
            'Start Course',
            {
                category: 'Search Results',
                value: data?.title,
                searchType: isAISearch ? 'AI' : 'Regular'
            });
    }, [data, isAISearch]);

    return (
        <div className={`${commonClasses.SearchResultItem} ${isPromoted && commonClasses.Promoted}`}>
            <Thumbnail additionalClass={commonClasses.Thumbnail} type={'courses'} alt={data?.title} />
            <div className={commonClasses.SearchResultItemInfo}>
                <div className={commonClasses.SearchResultItemInfoTop}>
                    <div className={commonClasses.TitleWrap}>
                        <a onClick={sendMixPanelEvent}
                           href={`/courses/${data?.link}?source=${location?.pathname}&sourceName=search`}
                           target={'_blank'} rel={'noopener noreferrer'}>
                            <Heading text={`${data?.title}`} type={'h5'}/>
                        </a>
                        <VisibilityViewerIcon
                            id={data?.id}
                        />
                    </div>
                    <Description data={data?.description}/>
                    <ProductLabelsList pageId={data?.id}/>
                </div>
                <div className={commonClasses.Wrap}>
                    <Label type={'courses'}/>
                    <PostDuration showIcon={false} duration={data?.duration}/>
                </div>
            </div>
        </div>
    );
};

export default Course;
